<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
<!--    <div class="header-top container-fuild hidden-xs">-->
<!--      <div class="container">-->
<!--        <div class="server pull-left">-->
<!--          <span class="glyphicon glyphicon-earphone"></span>020-38895289-->
<!--&lt;!&ndash;          <span class="glyphicon glyphicon-envelope"></span>liyunkun_11@163.com&ndash;&gt;-->
<!--          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务-->
<!--        </div>-->
<!--&lt;!&ndash;        <div class="shejiao pull-right">&ndash;&gt;-->
<!--&lt;!&ndash;          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！&ndash;&gt;-->
<!--&lt;!&ndash;          <span class="glyphicon glyphicon-hand-left"></span>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo" style="display: flex">
        <div class="header-nav-logo__image">
          <img src="@/assets/img/dot_logo.png">
        </div>
<!--        <div class="header-nav-logo__company-name">-->
<!--          <h2>广州数海科技有限公司</h2>-->

<!--        </div>-->

      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @touch="navClick(index,item.name)"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/dot_logo.png" alt="logo">
        <!--        <div class="header-nav-m-logo__company-name">-->
        <!--          <h4>广州数海科技有限公司</h4>-->
        <!--        </div>-->
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"

            data-toggle="collapse"
            data-target="#menu"
          >

            <router-link :to="item.path">
              <div @click="navClick(index,item.name)"
                   @touch="navClick(index,item.name)">
                {{ item.name }}
                <i class="underline"></i>
              </div>
            </router-link>


          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Header',
  data () {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: '首页',
      menuClass: 'glyphicon glyphicon-menu-down',
      navList: [
        {
          name: '首页',
          path: '/',
          children: []
        },
        {
          name: '产品中心',
          path: '/hardware',
          children: []
          // children: [
          //   {
          //     name: "TDD-LTE、FDD-LTE、WCDMA基站信源板",
          //     path: "/software/police"
          //   },
          //   {
          //     name: "手握式智能感知设备",
          //     path: "/software/monitor"
          //   }
          // ]
        },
        // {
        //   name: "相关服务",
        //   path: "/service",
        //   children: []
        // },
        {
          name: "解决方案",
          path: "/solution",
          children: []
        },
        {
          name: "云服务",
          path: "/newsinformation",
          children: []
        },
        {
          name: '公司概况',
          path: '/companyinfo',
          children: []
        },
        {
          name: '工作机会',
          path: '/jobchance',
          children: []
        },
        {
          name: '联系我们',
          path: '/contactus',
          children: []
        }
      ]
    }
  },
  methods: {
    navClick (index, name) {
      this.navIndex = index
      sessionStorage.setItem('navIndex', index)
      this.menuName = name
    },
    menuClick () {
      if (this.menuClass == 'glyphicon glyphicon-menu-down') {
        this.menuClass = 'glyphicon glyphicon-menu-up'
      } else {
        this.menuClass = 'glyphicon glyphicon-menu-down'
      }
    },
    menuActive(routerName){
      let navIndex=0
      let menuRouterName=['home', 'hardware','solution','newsinformation', 'companyinfo', 'jobchance', 'contactus']
      menuRouterName.forEach((item,index)=>{
        if(routerName.includes('newsdetail')){
          navIndex = 4
        }else if(routerName.includes(item)) {
          navIndex = index
        }
      })
      return navIndex
    }
  },
  watch:{
    '$route.path':function(newVal,oldVal){
      this.navIndex=this.menuActive(newVal)
      this.menuName = this.navList[this.navIndex].name
      // console.log(newVal)
      // this.navIndex = 0
    }
  }
}
</script>
<style scoped>
/* 顶部 */
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
}

#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  height: 110px;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: left;
  position: relative;

> div {
  align-items: center;
  justify-content: center;
}

}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 250px;
  /*height: 45px;*/
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo h2 {
  width: 355px;
  height: 45px;
  position: absolute;
  top: 10px;
  left: 110px;
  right: 0;
  bottom: 0;
  margin: auto;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 800px;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 250px;
    /*height: 45px;*/
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  #header .header-nav-m .header-nav-m-logo h4 {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 10px;
    left: 110px;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #003463;
    position: relative;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #003463;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }

  #header .header-nav .header-nav-wrapper > li:not(.active) > a:hover .underline {
   opacity: 0;
   width: 100%;
   left: 0;
  }

  #header .header-nav .header-nav-wrapper > li:not(.active) > a:hover {
    color: #000;
    text-decoration: none;
  }
}

@media screen and (min-width: 768px) and (max-width: 996px) {
  .container {
     width: unset;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue